export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('loading', {
            url: '/loading',
            component: 'loading'
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/auth.routes.js